module.exports = __webpack_public_path__ + "static/media/icon-grundversicherung-blau.9dc65cf5.svg";